<template>
  <v-dialog
    v-model="visible"
    v-if="media?.url && visible"
    max-width="800"
    persistent
  >
    <v-card class="rounded-lg">
      <div class="preview-container">
        <my-media
          :mediaType="media.type"
          :media="media.url"
          :height="800"
          :width="1200"
        />
      </div>
      <v-card-actions class="d-flex justify-center">
        <v-btn color="primary" @click="close">
          {{ $t('gallery.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MediaPreviewDialog',
  props: {
    modelValue: Boolean,
    media: Object,
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      },
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>

<style scoped>
.preview-container {
  height: 500px;
}
</style>
